<script>
  import Input from '@ui/pico/input.svelte';
  import { onMount } from 'svelte';

  import { editSiteSvc, getForms, getSite } from '../../services';
  import { pages } from '../../config';
  import FeIcon from '../components/fe-icon.svelte';
  import { goto } from '../../util';
  import FormsList from './forms-list.svelte';
  import Accordion from '../components/accordion/index.svelte';
  import { account, accountForms, siteLookup } from '../../store';

  export let params;

  let siteCount = 1;
  let formsListOpen = true;
  let showEditSiteForm = false;
  let siteName = '';
  let siteDescription = '';
  let site;
  let forms;

  $: siteForms = forms?.filter((f) => f.sid === params.sid);
  $: returnTo = '?from=sites.overview';
  $: sid = params.sid;

  $: {
    if ($account && !forms) {
      init();
    }
  }

  async function init() {
    if ($account && !forms) {
      site = $siteLookup[params.sid];
      if (!site) {
        goto(pages.dashboard.url);
        return;
      }
      forms = await getForms();
      siteName = site?.domain;
      siteDescription = site?.description;
    }
  }

  // @TODO: Site edit should be a redirect like all others
  function hideEdit() {
    showEditSiteForm = false;
  }
  async function finishEdit() {
    await editSiteSvc({
      sid: params.sid,
      domain: siteName,
      description: siteDescription,
    });
    site = await getSite({ sid: params.sid });
    hideEdit();
  }
  function triggerEditSite() {
    showEditSiteForm = true;
  }
  function triggerDeleteSite() {
    goto(pages.sites.delete.url, sid, returnTo);
  }
  async function triggerAddForm(ev) {
    if (ev.detail.add === 'form') {
      goto(pages.forms.add.url, sid, returnTo);
    }
  }
</script>

<form on:submit|preventDefault={finishEdit}>
  <dialog open={showEditSiteForm}>
    <article>
      <h3>Edit Site</h3>
      <Input type="text" bind:value={siteName} name="domain" label="Domain" />
      <Input
        type="text"
        bind:value={siteDescription}
        name="description"
        label="Description"
      />
      <footer>
        <button type="button" class="secondary" on:click={hideEdit}
          >Cancel</button
        >
        <button type="submit">Update</button>
      </footer>
    </article>
  </dialog>
</form>

<nav aria-label="breadcrumb">
  <ul>
    <li>
      <a href={pages.dashboard.url}>
        <i class="ri-home-3-line" />
      </a>
    </li>
    <li>
      {site?.domain || '...'}
    </li>
    <li>
      <FeIcon name="x-square" on:click={triggerDeleteSite} />
    </li>
    <li>
      <FeIcon name="edit" on:click={triggerEditSite} />
    </li>
  </ul>
</nav>

<header class="page-title">
  <h1>Site Overview</h1>
</header>

<Accordion
  title="Forms"
  icon="file-text"
  open={formsListOpen}
  on:add={triggerAddForm}
  add="form"
>
  <div slot="main">
    <svelte:component
      this={FormsList}
      forms={siteForms}
      {siteCount}
      {sid}
      {returnTo}
    />
  </div>
</Accordion>

<style>
  nav {
    height: 0;
    margin-bottom: 3rem;
  }
  dialog article {
    width: 600px;
  }
</style>
